module.exports = __webpack_public_path__ + "static/4-99fd8e249132e94daad12570f6dbde26.jpg";